import styled, { CreateStyled } from '@emotion/styled';
import { Theme } from './';

// @ts-ignore
export default styled as CreateStyled<Theme>;
